import axios from "axios";
import { apiUrl } from "../../api/common";
import { Addon, Product, ProductOption } from "../../types/product/product";

interface AddonResponse {
    returningAddons: Array<Addon>;
    productByAddons: Array<Product>;
}


export class ProductHandler {

    public static getProduct(productId: string): Promise<Product> {
        return new Promise<Product>(function (resolve, reject) {
            axios.get(apiUrl + '/products/' + productId, { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static GetUnicoProducts(): Promise<Array<Product>> {
        return new Promise<Array<Product>>(function (resolve, reject) {
            axios.get(apiUrl + '/products/unico', {}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getProducts(): Promise<Array<Product>> {
        return new Promise<Array<Product>>(function (resolve, reject) {
            axios.get(apiUrl + '/products', { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static GetCorrelatedProducts(maker: string, productId: string): Promise<Array<Product>> {
        return new Promise<Array<Product>>(function (resolve, reject) {
            axios.get(apiUrl + '/products/correlated/' + maker + '/' + productId, { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static GetMostViewedProducts(): Promise<Array<Product>> {
        return new Promise<Array<Product>>(function (resolve, reject) {
            axios.get(apiUrl + '/products/mostviewed', { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static GetLowStockProducts(): Promise<Array<Product>> {
        return new Promise<Array<Product>>(function (resolve, reject) {
            axios.get(apiUrl + '/products/lowstock', { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static GetAllLowStockProducts(): Promise<Array<Product>> {
        return new Promise<Array<Product>>(function (resolve, reject) {
            axios.get(apiUrl + '/products/lowstock/all', { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static GetOnSaleProducts(): Promise<Array<Product>> {
        return new Promise<Array<Product>>(function (resolve, reject) {
            axios.get(apiUrl + '/products/onsale', { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getProductsByCategoryId(categoryId: string): Promise<Array<Product>> {
        return new Promise<Array<Product>>(function (resolve, reject) {
            axios.get(apiUrl + '/products/category/' + categoryId, { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getProductsByCategoryCode(categoryCode: string): Promise<Array<Product>> {
        return new Promise<Array<Product>>(function (resolve, reject) {
            axios.get(apiUrl + '/products/category/code/' + categoryCode, { withCredentials: true }).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static searchProducts(query: string): Promise<Array<Product>> {
        return new Promise<Array<Product>>((resolve, reject) => {
            axios.get(apiUrl + '/products/search', {
                withCredentials: true, params: {
                    query: query
                }
            }).then((response: any) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err);
            });
        });
    }

    public static createProduct(newProduct: Product): Promise<any> {
        return new Promise<any>(function (resolve, reject) {
            axios.post(apiUrl + '/products', newProduct, { headers: { "app-key": "hello" } }).then((response: any) => {
                resolve(response.body);
            }).catch((err: any) => {
                reject(err);
            });
        });
    }

    public static getAddons(productId: string): Promise<AddonResponse> {
        return new Promise<AddonResponse>(function (resolve, reject) {
            axios.get(apiUrl + '/products/addons/' + productId, {}).then((response) => {
                resolve(response.data);
                console.log(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getOptionsAddons(optionId: string): Promise<Array<Addon>> {
        return new Promise<Array<Addon>>(function (resolve, reject) {
            axios.get(apiUrl + '/products/options/' + optionId + '/addons', {}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getProductOptions(productId: string): Promise<Array<ProductOption>> {
        return new Promise<Array<ProductOption>>(function (resolve, reject) {
            axios.get(apiUrl + '/products/' + productId + '/options', {}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static createProductAddon(newAddon: Addon): Promise<any> {
        return new Promise<any>(function (resolve, reject) {
            axios.post(apiUrl + '/products/addons/', newAddon, { headers: { "app-key": "hello" } }).then((response: any) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err);
            });
        });
    }

    public static createAddonOption(newProductOption: ProductOption): Promise<any> {
        return new Promise<any>(function (resolve, reject) {
            axios.post(apiUrl + '/products/addons/options/', newProductOption, { headers: { "app-key": "hello" } }).then((response: any) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err);
            });
        });
    }

    public static getProductPricing(productId: string): Promise<any> {
        return new Promise<any>(function (resolve, reject) {
            axios.get(apiUrl + '/products/pricing/' + productId, {}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

}
